import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  loading: {
    id: 'react-components.iFsDVR',
    defaultMessage: 'Loading',
  },
});
